import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Result } from 'app/core/models/result';
import { ModuleQuestionBankListModel } from 'app/module/models/module-question-bank-list.model';
import { ModuleService } from 'app/module/services/module.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ModuleQuestionBankReorderModel } from '../../models/module-question-bank-reorder.model';

@Component({
    selector: 'app-module-question-bank-list',
    templateUrl: './module-question-bank-list.component.html',
    styleUrls: ['./module-question-bank-list.component.css']
})
export class ModuleQuestionBankListComponent implements OnInit {
    @Input() moduleId: string;
    @Input() isEditMode: boolean = false;
    @Output() questionBanksUpdated: EventEmitter<string> = new EventEmitter<string>();
    selectedModuleQuestionBankId: string;
    errors: string[];
    moduleQuestionBanks: ModuleQuestionBankListModel[];

    constructor(
        private moduleService: ModuleService
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.moduleService.getModuleQuestionBanks(this.moduleId).subscribe(
            moduleQuestionBanks => {
                this.moduleQuestionBanks = moduleQuestionBanks;
            },
            error => this.errors = error.errorList
        );
    }

    onModuleQuestionBankAdded($event): void {
        this.questionBanksUpdated.emit("Updated");
        this.load();
    }

    deleteModuleQuestionBank(): void {
        this.moduleService.deleteModuleQuestionBank(this.selectedModuleQuestionBankId).subscribe(
            result => {
                this.questionBanksUpdated.emit("Updated");
                this.load();
            },
            error => this.errors = (<Result>error).errorList
        );
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.moduleQuestionBanks, event.previousIndex, event.currentIndex);

        let model = new ModuleQuestionBankReorderModel();
        var i;
        for (i = 0; i < this.moduleQuestionBanks.length; i++) {
            model.id = this.moduleQuestionBanks[i].id;
            model.zOrder = i + 1;
            this.moduleService.reorderModuleQuestionBank(model).subscribe(
                () => { },
                error => this.errors = (<Result>error).errorList
            );
        }
    }
}
